/**
 * @class
 * @classdesc Model for GateController on DB
 * * */
export default class GateController {
  /**
   *Constructor - sets a model for whitelist Data according to DB
   * @param {String} id
   * @param {String} type
   * @param {Int} version
   * @param {<Place>} place
   * @param {String} region
   * @param {Array.<Place>} places
   * @param {Array} zones
   * @param {String} validFrom
   * @param {String} validTo
   * @param {String} appRegistrationCode
   * @param {String} notificationEmails
   * @param {Boolean} autoApprove
   * @param {String} approvalMessage
   * @param {Array.<WhitelistUser>} users
   * @param {String} publicRegistrationLinkUuid
   * @param {Boolean} isPublicRegistrationLinkEnabled
   * @param {Boolean} startSessionsWithLPR
   * @param {String} registrationOpenUntil
   * @param {Boolean} chargeForSessions // By default the value of "chargeForSession" is true and can be modified directly in DB
   * @param {String} app
   * @param {String} appId
   * @param {Array.<PromoCode>} promoCodes
   * @param {String} lprActivities
   * @param {String} availabilityTableId
   * @param {String} availabilityTable
   * @param {String} discountPlanId
   * @param {String} discountPlan
   * @param {String} managers
   * @param {String} dynamicSessionsEnabled
   * @param {String} registrationRequestReceivedMessage
   * @param {String} discountPlan
   */

  #GateController = {}

  constructor(
    id,
    type,
    version,
    place,
    placeId,
    description,
    controllerId,
    phoneNumber,
    pinStateList,
    outputPinStateList,
    pinStateChangeTime,
    pinsToLog,
    pinStateChangeMap,
    activityRequiredPinStateMap,
    externalApiUsers,
    busyPinState,
    lastHeartbeat,
    lastRSSI,
    createdAt,
    updatedAt,
    deletedAt,
    gates,
    disableAutomaticRestart,
    lastAutomaticRestart,
    firmwareVersion,
    wifiIP,
    ethernetIP,
    uptime,
    inputs
  ) {
    this.#GateController.Id = id || 0
    this.#GateController.Type = type || ''
    this.#GateController.Version = version || 3
    this.#GateController.Place = place || {}
    this.#GateController.PlaceId = placeId || 0
    this.#GateController.Description = description || ''
    this.#GateController.ControllerId = controllerId || ''
    this.#GateController.PhoneNumber = phoneNumber || ''
    this.#GateController.PinStateList = pinStateList || ''
    this.#GateController.OutputPinStateList = outputPinStateList || ''
    this.#GateController.PinsToLog = pinsToLog || ''
    this.#GateController.PinStateChangeMap = pinStateChangeMap || ''
    this.#GateController.ActivityRequiredPinStateMap =
      activityRequiredPinStateMap || ''
    this.#GateController.ExternalApiUsers = externalApiUsers || []
    this.#GateController.BusyPinState = busyPinState || ''
    this.#GateController.LastHeartbeat = lastHeartbeat || ''
    this.#GateController.LastRSSI = lastRSSI || 0
    this.#GateController.CreatedAt = createdAt || ''
    this.#GateController.UpdatedAt = updatedAt || ''
    this.#GateController.DeletedAt = deletedAt || ''
    this.#GateController.Gates = gates || []
    this.#GateController.DisableAutomaticRestart =
      disableAutomaticRestart || false
    this.#GateController.LastAutomaticRestart = lastAutomaticRestart || ''
    this.#GateController.FirmwareVersion = firmwareVersion || 3
    this.#GateController.WifiIP = wifiIP || ''
    this.#GateController.EthernetIP = ethernetIP || ''
    this.#GateController.Uptime = uptime || 0
    this.#GateController.Inputs = inputs || []
  }

  /**
   * Get Whitelist Object
   * @return {Object} Whitelist Javascript object
   */
  getObject() {
    return this.#GateController
  }
}
